import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts'; // Update the path accordingly
import { CodeVerification } from './CodeVerification.tsx';
import { schema } from './schema.ts';

export const CodeVerificationForm: FC<GenericFormProps<typeof CodeVerification, typeof schema>> = ({
  onSubmit,
  buttonSlot,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={{ code: '' }}
    formContentElement={CodeVerification}
    schema={schema}
    onSubmit={onSubmit}
  />
);
